<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>FAQ관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          고객센터관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/notice/FaqList">FAQ관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
          <!-- 분류 -->
          <div class="form-group no-margin row mr-2">
            <div class="col-auto">
              <label class="col-form-label">분류</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="searchOptionsAll" v-model="OptionsTextAll" name="CatKind" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
                 <b-btn class="btn btn-xs btn-outline-info mr-2 mt-1" variant="outline-primary" style="width:100px;" @click="popupShowAddCat = true;" >분류 추가</b-btn>
            </div>
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="goNewDetail()" >등록</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
         <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center">No</td>
            <td style="text-align:center">분류</td>
            <td style="text-align:center" @click="localSort.sort('title')">질문<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('regId')">등록자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td style="text-align:center" @click="localSort.sort('regDt')">등록일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index" > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center" @click="edit(item.seq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">
              <b-form-select :options="searchOptions" :value="(item.boardCatSeq)" class="not-select custom-select custom-select-sm" style="width:max-content"></b-form-select>
            </td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.title}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.regId}}</td>
            <td class="align-middle text-center" @click="edit(item.seq)">{{item.regDt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default book-list">
      <div class="card-body" style="background-color:#fff;">
          <table class="table table-bordered table-hover">
            <tbody>
                <tr>
                    <td class="align-middle text-center">분류</td>
                    <td class="align-middle" colspan="3">
                         <b-form-select :options="searchOptions" v-model="data.row.boardCatSeq" class="custom-select custom-select-sm" style="width:30%"></b-form-select>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">제목</td>
                    <td class="align-middle text-center" colspan="3">
                        <input type="text" v-model="data.row.title" :class="{' form-control':true, 'is-invalid': errors.has('title')}"  v-validate="'required|min:2'"  name="title" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">내용</td>
                    <td class="align-middle text-left" colspan="3">
                       <!-- <quill-editor
                            ref="myQuillEditor"
                            v-model="data.row.content"
                            :style="'min-height:300px'"
                        />  -->
                        <!-- @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)" -->
                        <jodit-editor
                          v-model="data.row.content"
                          :config="jodit_config.config"
                          :buttons="jodit_config.buttons"
                          :plugins="jodit_config.plugins"
                          :class="{'is-invalid': errors.has('content')}"
                          v-validate="'required|min:2'"
                          name="content"
                          :style="'min-height:300px;'"
                        />
                    </td>
                </tr>
                 <tr >
                    <td class="align-middle text-center">게시일</td>
                    <td class="align-middle d-flex align-items-center">
                        <datepicker
                            v-model="data.row.postDt"
                            v-validate="'required'"
                            name="postDt"
                            :class="{'is-invalid': errors.has('postDt')}"
                            :bootstrapStyling="true"
                            :monday-first="true"
                            :full-month-name="true"
                            placeholder="Select date"
                            :calendar-button="true"
                            calendar-button-icon="far fa-calendar"
                            :clear-button="true"
                            :style="'width:calc(100% - 80px);'" />
                        <input type="checkbox" v-model="Datedata.postDtChk" class="ml-2" @change="changeDate('now')">
                        <label class="form-check-label ml-1 ">즉시</label>
                    </td>
                    <td class="align-middle text-center">종료일</td>
                    <td class="align-middle d-flex align-items-center">
                        <datepicker
                            v-model="data.row.endDt"
                            v-validate="'required'"
                            name="endDt"
                            :class="{'is-invalid': errors.has('endDt')}"
                            :bootstrapStyling="true"
                            :monday-first="true"
                            :full-month-name="true"
                            placeholder="Select date"
                            :calendar-button="true"
                            calendar-button-icon="far fa-calendar"
                            :clear-button="true"
                            :style="'width:calc(100% - 80px);'"/>
                        <input type="checkbox" v-model="Datedata.endDtChk" class="ml-2" @change="changeDate('end')">
                        <label class="form-check-label ml-1">영구</label>
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">등록자ID</td>
                    <td class="align-middle ">
                        <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.viewCnt')}" v-model="data.row.regAdminSeq"  name="regId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">등록일시</td>
                    <td class="align-middle ">
                        <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.viewCnt')}" v-model="data.row.regDt"  name="regId" style="width: 100%"  />
                    </td>
                </tr>
                <tr>
                    <td class="align-middle text-center">수정자ID</td>
                    <td class="align-middle ">
                        <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.viewCnt')}" v-model="data.row.updAdminSeq"  name="regId" style="width: 100%"  />
                    </td>
                    <td class="align-middle text-center">수정일시</td>
                    <td class="align-middle ">
                        <input type="text" :class="{'not-text form-control':true, 'is-invalid': errors.has('edit.viewCnt')}" v-model="data.row.updDt"  name="regId" style="width: 100%"  />
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="footer mt-3">
          <div class="float-right">
              <b-button @click="remove()" class="btn btn-b btn-danger mr-2" variant="info mr-2">삭제</b-button>
              <b-button @click="search()" class="btn btn-b btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
              <b-button @click="save()" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
          </div>
        </div>
      </div>
    </div>
    <!-- // 목차/차시 -->
    <b-modal id="uploadModalFiles" size="s" title="개체연결" v-model="popupShowAddCat">
      <BoardCatList :catType="'03'"/>
    </b-modal>
  </ContentWrapper>
</template>
<style scoped>
  .quill-editor.is-invalid, .vdp-datepicker.is-invalid {
    border:1px solid #f05050
  }
</style>

<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getFAQList,getFAQItem,setFAQList,deleteFAQList} from "@/api/notice/FAQListApi";
import {getBoardCatList,setBoardCatList, deleteBoardCatList} from "@/api/notice/BoardCatApi";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
import BoardCatList from "../notice/component/BoardCatList";
import Datepicker from 'vuejs-datepicker'
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

// import VueQuillEditor from 'vue-quill-editor'

// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme

// Vue.use(VueQuillEditor, /* { default global options } */)

// jodit Editor
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
import { jodit_config } from '@/components/Common/jodit_config'

export default {
  components: {SchDateRange, SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword, Datepicker,BoardCatList, JoditEditor},

  setup(props, {root}){
    const selectedContSeq = '';
    const uploadImageFile = ref('');

    const searchOptionsAll = ref([]);
    const searchOptions = ref([]);
    const OptionsTextAll = ref('0');
    const OptionsText = ref('1');
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)

    const fileName = ref('');

    const searchText = ref('');
    const searchValue = ref([]);
    const searchShowValue = ref([]);

    const popupShowAddCat = ref(false);

    const Datedata = reactive({
      postDt: new Date(),
      postDtChk : false,
      endDt: new Date('9999-12-31'),
      endDtChk : false,
    })
    

    const loadData = async () => {
      data.params.bookTypeCd = '330001';
      let result = await getFAQList(data.params);
      data.list = result.data;
      data.count = result.data.length;
      root.$_localSort.set(data.list);

      searchValue.value = _.cloneDeep(data.list);
      OptionsText.value = '0'
      getBoardCatOption();
    }

    const getBoardCatOption = async() =>{
        searchOptionsAll.value = [];
        searchOptions.value = [];
        let result = await getBoardCatList('03');
        searchOptionsAll.value.push({
          value : 0,
          text  : '전체',
        });
        if(result.data){
          result.data.map((row,i) => {
            searchOptionsAll.value.push({
              value : row.seq,
              text  : row.categoryName,
            })
            searchOptions.value.push({
              value : row.seq,
              text  : row.categoryName,
            })
          });
        }
    }


    const insertFileName = (e) =>{
       var input = e.target;
       fileName.value = input.files[0].name; //파일명
      
     if (input.files && input.files[0])
      { 
        var reader = new FileReader();
          reader.onload = (e) => {          
             uploadImageFile.value = e.target.result; //파일데이터
          }
          reader.readAsDataURL(input.files[0]);
      }
    }
    const goNewDetail = () =>{
      data.params.mode = "detail";
      data.row = [];
      data.row.content = '';
      data.row.boardCatSeq = searchOptions.value[0].value;
    }
    
    const changeDate = (type) =>{
       let _temp = type == 'now' ? data.row.postDt : data.row.endDt;

       if(type == 'now'){
         if(Datedata.postDtChk == true){
           data.row.postDt = new Date();
           Datedata.postDt = _.cloneDeep(_temp);
         }
         else{
           data.row.postDt = Datedata.postDt;
         }
       }else{
         if(Datedata.endDtChk == true){
          data.row.endDt = new Date(9998,11,31);
          Datedata.endDt =  _.cloneDeep(_temp);
         }
         else{
           data.row.endDt = Datedata.endDt;
         }
       }
    }

    onMounted(loadData)

    return{
      jodit_config,
      searchText,
      searchValue,
      searchShowValue,
      selectedContSeq,
      uploadImageFile,
      fileName,
      insertFileName,
      searchOptions,
      searchOptionsAll,
      OptionsTextAll,
      OptionsText,
      dataObject,
      _dataObject,
      data,
      Datedata,
      goNewDetail,
      popupShowAddCat,
      getBoardCatOption,
      changeDate,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }
  },
}

function methods() {
  var context = {};
  context["getFAQList"] = getFAQList;
  context["setFAQList"] = setFAQList;
  context["deleteFAQList"] = deleteFAQList;
  context["getBoardCatList"] = getBoardCatList;
  context["getFAQItem"] = getFAQItem;

   // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getFAQList",context,_params);
  }

  // 상세
  async function edit(_seq){
    let _params = {
      seq: _seq
    }
    let noticeInfo = await this.dataAction.execute("getFAQItem",context, _params);
    this.OptionsText = noticeInfo.data.boardCatSeq - 1;
  }

   // 저장
  async function save() { 
    if(!this.data.row.content || this.data.row.content.length < 2){
        alert("내용을 입력해주세요.");
        return false;
    }
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      alert('필수 입력 항목을 확인해주세요.');
      return false;
    }

    if (!confirm("내용을 저장 하시겠습니까?")) {
        // 취소(아니오) 버튼 클릭 시 이벤트
        return false;
    } else {
      let params;
      if(this.data.row.seq !=null){
        params = {
          seq : this.data.row.seq,
          boardCatSeq :this.data.row.boardCatSeq,
          title: this.data.row.title,
          content : this.data.row.content,
          regAdminSeq : this.data.row.regAdminSeq,
          endDt : moment(this.data.row.endDt).format('YYYY-MM-DD HH:mm:ss'),
          postDt : moment(this.data.row.postDt).format('YYYY-MM-DD HH:mm:ss'),
        }
      }else{
        params = {
          boardCatSeq :this.data.row.boardCatSeq,
          title: this.data.row.title,
          content : this.data.row.content,
          regAdminSeq : this.data.row.regAdminSeq,
          endDt : moment(this.data.row.endDt).format('YYYY-MM-DD HH:mm:ss'),
          postDt : moment(this.data.row.postDt).format('YYYY-MM-DD HH:mm:ss'),
        }
      }
      let result = await setFAQList(params);
      if( result.data ){
        alert('저장 완료되었습니다.');
      }
    }
  }
  
  async function remove() { 
    if (!confirm("내용을 삭제 하시겠습니까?")) {
        // 취소(아니오) 버튼 클릭 시 이벤트
        return false;
    } else {
      let params;
      if(this.data.row.seq !=null){
        params = {
          seq : this.data.row.seq,
        }
      }
      let result = await deleteFAQList(params);
      if( result.data ){
        alert('삭제되었습니다.');
        let _params = this.data.params;
        this.dataAction.execute("getFAQList",context,_params);
      }
    }
  }


  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  async function saveUploadlist(item,type) {
    if(type =='excel'){
        await saveCsContExcel(item.params);
    }
    else{
      await saveCsCont(item.params);
    }
    if( item.version == 'unit'){
      this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo , null);
    }
    else{
      //this.getAtrbListExcel(item.delete_param.contSeq, '202004' , item.atrbInfo);
      this.getDepth3Excel(item.delete_param.contSeq , item.atrbInfo , item.params);
    }
  }

  const downloadAs = (fileDivCd, url, name) => {
        let fullUrl = aws_cdn_path + url;
        Axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
    };

  return {
    search,
    edit,
    reset,
    save,
    remove,
    saveUploadlist,
    downloadAs,
    }
}

</script>
